import { createContext, PropsWithChildren, useReducer } from "react";

import { CreateSourceWikipediaAction } from "@/pages/sources/components/create/sources/wikipedia/actions";
import {
  SOURCE_WIKIPEDIA_DEFAULT_CRAWL_DEPTH,
  SOURCE_WIKIPEDIA_DEFAULT_LINKS_PER_PAGE,
  SOURCE_WIKIPEDIA_DEFAULT_MAX_PAGES,
} from "@/pages/sources/components/create/sources/wikipedia/constants";
import createSourceWikipediaReducer from "@/pages/sources/components/create/sources/wikipedia/reducer";
import {
  CreateSourceWikipediaPhase,
  CreateSourceWikipediaState,
} from "@/pages/sources/components/create/sources/wikipedia/types";

export interface CreateSourceWikipediaContextShape {
  state: CreateSourceWikipediaState;
  dispatch: React.Dispatch<CreateSourceWikipediaAction>;
}

export const DEFAULT_STATE: CreateSourceWikipediaState = {
  sourceName: "",
  seedUrl: "",
  linksPerPage: SOURCE_WIKIPEDIA_DEFAULT_LINKS_PER_PAGE,
  crawlDepth: SOURCE_WIKIPEDIA_DEFAULT_CRAWL_DEPTH,
  maxPages: SOURCE_WIKIPEDIA_DEFAULT_MAX_PAGES,
  phase: CreateSourceWikipediaPhase.IDLE,
  error: null,
  shouldShowErrors: false,
};

export const CreateSourceWikipediaContext = createContext<CreateSourceWikipediaContextShape | null>(
  null,
);
CreateSourceWikipediaContext.displayName = "CreateSourceWikipediaContext";

const CreateSourceWikipediaProvider = ({ children }: PropsWithChildren) => {
  const [state, dispatch] = useReducer(createSourceWikipediaReducer, DEFAULT_STATE);

  return (
    <CreateSourceWikipediaContext.Provider value={{ state, dispatch }}>
      {children}
    </CreateSourceWikipediaContext.Provider>
  );
};

export default CreateSourceWikipediaProvider;
